import React from 'react';
import { ArrowLeft, Eye } from 'lucide-react';
import UserMenu from '../components/UserMenu';

/**
 * Staff "Eye Examination Chart" view — an iframe around /exam-chart/,
 * the standalone vanilla-JS app in optivet-webapp/ (served as static
 * files by FastAPI). The exam chart is deliberately not part of this
 * React bundle: it predates it and manages its own DOM, canvas drawing
 * and API calls.
 *
 * Two consequences of the iframe approach:
 *   - ProtectedRoute gates this wrapper, but /exam-chart/ itself is a
 *     public static path — anyone who knows the URL can load the chart
 *     directly without staff auth (its API calls are still server-side
 *     auth-checked, but the UI and its settings endpoints are not).
 *   - clipboard-write is granted so the chart's copy-buttons work
 *     inside the iframe.
 *
 * Layout: the chart targets a fixed 1920×1050 clinical workstation, so
 * vertical space is scarce — the header is kept deliberately compact
 * (py-2, no hero elements) and pinned; the iframe takes the remaining
 * height via flex-1 so the page never double-scrolls.
 */
const EyeExamChart = ({ navigateTo }) => {
  return (
    <div className="h-screen flex flex-col bg-gray-50 overflow-hidden">
      <header className="bg-white shadow-sm border-b border-gray-200 shrink-0">
        <div className="max-w-full px-4 sm:px-6">
          <div className="flex justify-between items-center py-2">
            <div className="flex items-center space-x-3">
              <button
                onClick={() => navigateTo('staff-portal')}
                className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg"
              >
                <ArrowLeft className="h-5 w-5" />
              </button>
              <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center">
                <Eye className="h-4 w-4 text-white" />
              </div>
              <h1 className="text-base font-bold text-gray-900">Eye Examination Chart</h1>
            </div>
            <UserMenu navigateTo={navigateTo} />
          </div>
        </div>
      </header>
      <iframe
        src="/exam-chart/"
        title="Optivet Eye Exam Chart"
        className="flex-1 w-full"
        style={{ border: 'none', display: 'block' }}
        allow="clipboard-write"
      />
    </div>
  );
};

export default EyeExamChart;
